import { ENV } from '@/env'

export function getBaseUrl() {
  if ("production" === 'preview') return `https://${"nelsonlaidev-git-main-nelsonlai.vercel.app"}`

  return "https://nelsonlai.dev"
}
